<template>
    <div class="m-auto px-2 lg:px-8">
        <div class="flex flex-col md:flex-row pt-4 items-center md:mb-4 gap-3">
            <h1 class="font-bold text-lg md:text-3xl">Inserimento timesheet</h1>
            <WeekSwitcher v-model:date="date" class="w-full max-w-[24rem]"></WeekSwitcher>
            <div class="flex justify-self-end w-28">
                <Field v-model="filterDate" :label-visible="false"
                       placeholder="Anno" type="number"></Field>
            </div>
            <div class="flex justify-self-end">
                <Field v-model="search" :label-visible="false"
                       placeholder="Cerca" type="text"></Field>
            </div>
            <div class="flex justify-self-end">
                <Star class="text-yellow-500 w-8 h-8" :starred="starred" @click="toggleStar"></Star>
            </div>
        </div>
        <Alert v-show="error" class="bg-next-orange">{{ error }}</Alert>
        <TimesheetTable
            @error="error = $event"
            @refreshRequired="refresh"
            v-model:date="date"
            :records="Records"
            :loading="loading"
            class="hidden lg:block"
        ></TimesheetTable>
        <TimesheetTableMobile
            v-model:error="error"
            v-model:date="date"
            :records="Records"
            :loading="loading"
            @refreshRequired="refresh"
            class="block lg:hidden"
        ></TimesheetTableMobile>
    </div>

</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import WeekSwitcher from "@/components/WeekSwitcher.vue";
import TimesheetTable from "@/components/Timesheet/TimesheetTable.vue";
import TimesheetTableMobile from "@/components/Timesheet/TimesheetTableMobile.vue";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";
import timesheetManager from "@/api/Timesheet";
import moment from "moment/moment";
import Field from "@/components/Field.vue";
import Star from "@/components/Star.vue";
import Alert from "@/components/Alert.vue";

@Options({
    name: 'InserimentoTimesheet',
    components: {
        Alert,
        Star,
        Field,
        TimesheetTableMobile,
        TimesheetTable,
        WeekSwitcher
    },
    computed: {
        Records(){
            if (this.search.length){
                return  this.records.map((record: any) => {
                    const visible = record.cod_nodo?.toLowerCase().includes(this.search.toLowerCase())
                        || record.titolo?.toLowerCase().includes(this.search.toLowerCase())
                        || record.committente_denominazione?.toLowerCase().includes(this.search.toLowerCase())
                    return  {
                        ...record, hidden : !visible
                    }
                })
            }
            return this.records
        }
    }
})
export default class InserimentoTimesheet extends Vue {

    loading = false
    date = ''
    records: any = []
    search = ''
    starred = false
    timer:any = 0
    filterDate = ''
    error = ''

    startWeek() {
        return moment(this.date).startOf('week').clone()
    }

    created() {
        this.date = moment().format('YYYY-MM-DD')
    }

    toggleStar() {
        this.starred = !this.starred
        clearTimeout(this.timer)
        this.timer = setTimeout(this.refresh, 0)
    }

    @Watch('filterDate')
    filterDateChange() {
        clearTimeout(this.timer)
        this.timer = setTimeout(this.refresh, 200)
    }

    @Watch('date')
    refresh() {
        this.loading = true
        timesheetManager.weeklyTimesheet({
            start: this.startWeek().format('YYYY-MM-DD'),
            anno: this.filterDate,
            starred: this.starred ? 1 : 0
        }).then((res: any) => {
            this.records = res.data
        }).finally(() => {
            this.loading = false
        })
    }
}
</script>


<style lang="scss">

</style>
